export default "/images/vendor/flag-icon-css/flags/4x3/ug.svg?83f4207b3f42150d667b04e7fe6b6a47";